export default __webpack_public_path__ + "static/media/sample-qr.3fecbce7.png";